import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import {
  resetPassword,
  createAccount,
  resendEmailVerificationEmail,
  requestReactivateAccount,
  getcreateAccountInfo,
} from "./controller";

export enum actionTypes {
  UPDATE_PASSWORD = "UPDATE_PASSWORD",
  TOGGLE_USER_ERR = "TOGGLE_USER_ERR",
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  LOGIN_SUCCESSS = "LOGIN_SUCCESS",
  LOGIN_FAILURE = "LOGIN_FAILURE",
  TOGGLE_MFA_STEP = "TOGGLE_MFA_STEP",
  CLEAR_ERROR_STATE = "CLEAR_ERROR_STATE",
  RESEND_VERIFICATION_EMAIL = "RESEND_VERIFICATION_EMAIL",
  REACTIVATE_ACCOUNT = "REACTIVATE_ACCOUNT",
  GET_CREATE_ACCOUNT_INFO = "GET_CREATE_ACCOUNT_INFO",
  UPDATE_USER_INPUT = "UPDATE_USER_INPUT",
}

type ThunkA = ThunkAction<void, {}, {}, AnyAction>;
type ThunkD = ThunkDispatch<{}, {}, AnyAction>;

export const resetPasswordAction =
  (email: string, resetToken: string, password: string): ThunkA =>
  (dispatch: ThunkD): void => {
    dispatch({
      type: actionTypes.UPDATE_PASSWORD,
      payload: resetPassword(email, resetToken, password),
    });
  };

export const toggleUserErrorAction = (userErr: boolean) => ({
  type: actionTypes.TOGGLE_USER_ERR,
  payload: userErr,
});

export const clearErrorStateAction = () => ({
  type: actionTypes.CLEAR_ERROR_STATE,
  payload: null,
});

export const loginSuccessAction = (res: any) => ({
  type: actionTypes.LOGIN_SUCCESSS,
  payload: res,
});

export const loginFailureAction = (err: any) => ({
  type: actionTypes.LOGIN_FAILURE,
  payload: err,
});

export const toggleMfaAction = (show: boolean) => ({
  type: actionTypes.TOGGLE_MFA_STEP,
  payload: show,
});

export const createAccountAction =
  (
    email: string,
    password: string,
    inviteId: string,
    firstName: string,
    lastName: string,
    dateFormat: any,
    timeZone: any,
    timeFormat: any,
    state: any
  ): ThunkA =>
  (dispatch: ThunkD): void => {
    dispatch({
      type: actionTypes.CREATE_ACCOUNT,
      payload: createAccount(
        email,
        password,
        inviteId,
        firstName,
        lastName,
        dateFormat,
        timeZone,
        timeFormat,
        state
      ),
    });
  };

export const resendEmailVerificationEmailAction =
  (email: string, clientId: string, redirectUri: string): ThunkA =>
  (dispatch: ThunkD): void => {
    dispatch({
      type: actionTypes.RESEND_VERIFICATION_EMAIL,
      payload: resendEmailVerificationEmail(email, clientId, redirectUri),
    });
  };

export const reactivateAccountAction =
  (token: string, email: string, redirect: Function): ThunkA =>
  (dispatch: ThunkD): void => {
    dispatch({
      type: actionTypes.REACTIVATE_ACCOUNT,
      payload: requestReactivateAccount(token, email)
        .then((resp: any) => {
          redirect();
          return resp;
        })
        .catch((err: any) => {
          redirect();
          throw err;
        }),
    });
  };

export function getCreateAccountInfoAction(inviteId: string): ThunkA {
  return (dispatch: ThunkD): void => {
    dispatch({
      type: actionTypes.GET_CREATE_ACCOUNT_INFO,
      payload: getcreateAccountInfo(inviteId)
        .then((resp: any) => {
          return resp;
        })
        .catch((err: any) => {
          throw err;
        }),
    });
  };
}

export function updateUserInputAction(field: string, value: string) {
  return {
    type: actionTypes.UPDATE_USER_INPUT,
    payload: {
      field,
      value,
    },
  };
}
